module.exports = __webpack_public_path__ + "img/dy05.d1188edd.png";